import Model from '~/models/base/Model';
import { encodeStringToBase64 } from '~/modules/helpers/crypto';

/**
 * class representing Login
 * @extends Model
 * @author FM
 */
export default class Login extends Model {
    static _url = `${Model._url}/login/`;

    constructor(id = null) {
        super(id);
    }

    static login(username, password) {
        //TODO: pass password encrypted
        const requestPayload = {
            username: username,
            password: password,
            hash: window.location.hash
        };
        const requestUrl = `${this._url}login/`;
        return this.api.post(requestUrl, requestPayload);
    }

    static logout() {
        const requestUrl = `${this._url}logout/`;
        return this.api.get(requestUrl);
    }

    static forceChangePassword(currentPassword, newPassword) {
        const encode = encodeStringToBase64;
        const requestPayload = {
            current_user_password: encode(currentPassword),
            new_password: encode(newPassword)
        };
        const requestUrl = `${this._url}force_change/`;
        return this.api.put(requestUrl, requestPayload);
    }

    static sso(client) {
        const requestUrl = `${this._url}sso/${client ?? 'sumo'}/`;
        return this.api.get(requestUrl);
    }
}
